{
  "ACTIVATE": {
    "pt-BR": "Ativar",
    "en-US": "Activate",
    "es-ES": "Activar"
  },
  "ATTENDANT_ID_REQUIRED": {
    "pt-BR": "O ID do atendente é obrigatório.",
    "en-US": "Attendant ID is required.",
    "es-ES": "Se requiere el ID del asistente."
  },
  "AN_ERROR_HAS_OCCURRED_WHILE_PROCESSING_YOUR_REQUEST": {
    "pt-BR": "Ocorreu um erro ao processar a sua solicitação!",
    "en-US": "An error has occurred while processing your request!",
    "es-ES": "¡Ha ocurrido un error al procesar su solicitud!"
  },
  "CANCEL": {
    "pt-BR": "Cancelar",
    "en-US": "Cancel",
    "es-ES": "Anular"
  },
  "CHANGE_LANGUAGE": {
    "pt-BR": "Mudar Idioma",
    "en-US": "Change Language",
    "es-ES": "Cambiar Idioma"
  },
  "CHARACTERS": {
    "pt-BR": "caracteres",
    "en-US": "characters",
    "es-ES": "caracteres"
  },
  "CONFIRM": {
    "pt-BR": "Confirmar",
    "en-US": "Confirm",
    "es-ES": "Confirmar"
  },
  "CODE": {
    "pt-BR": "Código",
    "en-US": "Code",
    "es-ES": "Código"
  },
  "COULD_NOT_ACTIVATE_THE_ITEM": {
    "pt-BR": "Não foi possível ativar o item!",
    "en-US": "Could not activate the item!",
    "es-ES": "No se ha podido activar el elemento!"
  },
  "COULD_NOT_DELETE_THE_ITEM": {
    "pt-BR": "Não foi possível excluir o item!",
    "en-US": "Could not delete the item!",
    "es-ES": "No se ha podido eliminar el elemento!"
  },
  "COULD_NOT_INACTIVATE_THE_ITEM": {
    "pt-BR": "Não foi possível inativar o item!",
    "en-US": "Could not inactivate the item!",
    "es-ES": "No se ha podido desactivar el elemento!"
  },
  "DELETE": {
    "pt-BR": "Deletar",
    "en-US": "Delete",
    "es-ES": "Eliminar"
  },
  "DESCRIPTION": {
    "pt-BR": "Descrição",
    "en-US": "Description",
    "es-ES": "Descripción"
  },
  "DETAILS": {
    "pt-BR": "Detalhes",
    "en-US": "Details",
    "es-ES": "Detalles"
  },
  "DATE": {
    "pt-BR": "Data",
    "en-US": "Date",
    "es-ES": "Fecha"
  },
  "DONE": {
    "pt-BR": "Feito",
    "en-US": "Done",
    "es-ES": "Hecho"
  },
  "DO_YOU_REALLY_WANT_TO_DELETE_THIS_ITEM": {
    "pt-BR": "Deseja realmente excluir este item?",
    "en-US": "Do you really want to delete this item?",
    "es-ES": "¿Realmente quieres eliminar este elemento?"
  },
  "DO_YOU_REALLY_WANT_TO_DELETE_THE_REGISTER": {
    "pt-BR": "Tem certeza de que deseja excluir o registro",
    "en-US": "Are you sure you want to delete the record",
    "es-ES": "¿Estás seguro de que deseas eliminar el registro"
  },
  "DO_YOU_REALLY_WANT_TO_ACTIVATE_THIS_ITEM": {
    "pt-BR": "Deseja realmente ativar este item?",
    "en-US": "Do you really want to activate this item?",
    "es-ES": "¿Realmente quieres activar este elemento?"
  },
  "DO_YOU_REALLY_WANT_TO_INACTIVATE_THIS_ITEM": {
    "pt-BR": "Deseja realmente inativar este item?",
    "en-US": "Do you really want to inactivate this item?",
    "es-ES": "¿Realmente quieres inactivar este elemento?"
  },
  "DO_YOU_WANT_TO_EXIT": {
    "pt-BR": "Deseja sair?",
    "en-US": "Do you want to exit?",
    "es-ES": "¿Quiere salir?"
  },
  "EDIT": {
    "pt-BR": "Editar",
    "en-US": "Edit",
    "es-ES": "Editar"
  },
  "EMAIL": {
    "pt-BR": "E-mail",
    "en-US": "E-mail",
    "es-ES": "Correo electrónico"
  },
  "PHONE": {
    "pt-BR": "Telefone",
    "en-US": "Phone",
    "es-ES": "Teléfono"
  },
  "ENGLISH": {
    "pt-BR": "Inglês (EUA)",
    "en-US": "English (USA)",
    "es-ES": "Inglés (Estados Unidos)"
  },
  "ENTER_YOUR_EMAIL": {
    "pt-BR": "Digite seu e-mail",
    "en-US": "Enter your e-mail",
    "es-ES": "Introduzca su correo electrónico"
  },
  "ENTER_YOUR_PASSWORD": {
    "pt-BR": "Digite sua senha",
    "en-US": "Enter your password",
    "es-ES": "Introduzca su contraseña"
  },
  "ENTRIES": {
    "pt-BR": "registros",
    "en-US": "entries",
    "es-ES": "entradas"
  },
  "GENERAL_DATA": {
    "pt-BR": "Dados gerais",
    "en-US": "General data",
    "es-ES": "Datos generales"
  },
  "HELLO": {
    "pt-BR": "Olá",
    "en-US": "Hello",
    "es-ES": "Hola"
  },
  "INACTIVATE": {
    "pt-BR": "Inativar",
    "en-US": "Inactivate",
    "es-ES": "Inactivar"
  },
  "INACTIVE": {
    "pt-BR": "Inativo",
    "en-US": "Inactive",
    "es-ES": "Inactivo"
  },
  "ACTIVE": {
    "pt-BR": "Ativo",
    "en-US": "Active",
    "es-ES": "Activo"
  },
  "AUTHENTICATION_HAPPENS_THROUGH_VIDEOSOFT_CENTRALIZED_LOGIN": {
    "pt-BR": "A autenticação agora acontece pelo login centralizado da VideoSoft.",
    "en-US": "Authentication now happens through VideoSoft's centralized login.",
    "es-ES": "La autenticación ahora se realiza mediante el inicio de sesión centralizado de VideoSoft."
  },
  "INVALID_CNPJ": {
    "pt-BR": "CNPJ inválido!",
    "en-US": "Invalid CNPJ!",
    "es-ES": "¡CNPJ no válido!"
  },
  "INVALID_DATE": {
    "pt-BR": "Data inválida. Use o formato YYYY-MM-DD.",
    "en-US": "Invalid date. Use the YYYY-MM-DD format.",
    "es-ES": "Fecha inválida. Use el formato YYYY-MM-DD."
  },
  "INVALID_DATE_RANGE": {
    "pt-BR": "A data inicial deve ser menor ou igual à data final.",
    "en-US": "Start date must be less than or equal to end date.",
    "es-ES": "La fecha de inicio debe ser menor o igual a la fecha de fin."
  },
  "INVALID_EMAIL_FORMAT": {
    "pt-BR": "Formato de e-mail inválido!",
    "en-US": "Invalid e-mail format!",
    "es-ES": "¡Formato de e-mail no válido!"
  },
  "INVALID_FORMAT": {
    "pt-BR": "Formato inválido!",
    "en-US": "Invalid format!",
    "es-ES": "¡Formato no válido!"
  },
  "ITEM_SUCCESSFULLY_ACTIVATED": {
    "pt-BR": "Item ativado com sucesso!",
    "en-US": "Item successfully activated!",
    "es-ES": "Elemento activado correctamente!"
  },
  "ITEM_SUCCESSFULLY_DELETED": {
    "pt-BR": "Item excluído com sucesso!",
    "en-US": "Item successfully deleted!",
    "es-ES": "Elemento eliminado correctamente!"
  },
  "ITEM_SUCCESSFULLY_INACTIVATED": {
    "pt-BR": "Item inativado com sucesso!",
    "en-US": "Item successfully inactivated!",
    "es-ES": "Elemento desactivado correctamente!"
  },
  "LOG_IN_TO_CONTINUE": {
    "pt-BR": "Faça login para continuar",
    "en-US": "Log in to continue",
    "es-ES": "Inicia sesión para continuar"
  },
  "LOGIN_WITH_VIDEOSOFT": {
    "pt-BR": "Entrar com VideoSoft",
    "en-US": "Sign in with VideoSoft",
    "es-ES": "Iniciar sesión con VideoSoft"
  },
  "NEW": {
    "pt-BR": "Novo(a)",
    "en-US": "New",
    "es-ES": "Nuevo(a)"
  },
  "NO": {
    "pt-BR": "Não",
    "en-US": "No",
    "es-ES": "No"
  },
  "MUST_BE_A_MAXIMUM": {
    "pt-BR": "Deve ter no máximo",
    "en-US": "Must be a maximum",
    "es-ES": "Debe tener un máximo"
  },
  "MUST_BE_A_MINIMUM": {
    "pt-BR": "Deve ter no mínimo",
    "en-US": "Must be a minimum",
    "es-ES": "Debe tener un mínimo"
  },
  "OF": {
    "pt-BR": "de",
    "en-US": "of",
    "es-ES": "de"
  },
  "PASSWORD": {
    "pt-BR": "Senha",
    "en-US": "Password",
    "es-ES": "Clave"
  },
  "PORTUGUESE": {
    "pt-BR": "Português (Brasil)",
    "en-US": "Portuguese (Brazil)",
    "es-ES": "Portugués (Brasil)"
  },
  "RECORDS": {
    "pt-BR": "Cadastros",
    "en-US": "Records",
    "es-ES": "Registros"
  },
  "REQUEST_PROCESSED_SUCCESSFULLY": {
    "pt-BR": "Solicitação processada com sucesso!",
    "en-US": "Request processed successfully!",
    "es-ES": "¡Solicitud procesada con éxito!"
  },
  "REQUIRED": {
    "pt-BR": "Obrigatório",
    "en-US": "Required",
    "es-ES": "Obligatorio"
  },
  "REQUIRED_FIELD": {
    "pt-BR": "Campo obrigatório!",
    "en-US": "Required field!",
    "es-ES": "¡Campo obligatorio!"
  },
  "SAVE": {
    "pt-BR": "Salvar",
    "en-US": "Save",
    "es-ES": "Ahorrar"
  },
  "LIST": {
    "pt-BR": "Lista",
    "en-US": "List",
    "es-ES": "Lista"
  },
  "CALENDAR": {
    "pt-BR": "Calendário",
    "en-US": "Calendar",
    "es-ES": "Calendario"
  },
  "SEARCH": {
    "pt-BR": "Pesquisar",
    "en-US": "Search",
    "es-ES": "Buscar"
  },
  "SHOWING": {
    "pt-BR": "Mostrando",
    "en-US": "Showing",
    "es-ES": "Mostrando"
  },
  "SPANISH": {
    "pt-BR": "Espanhol (Espanha)",
    "en-US": "Spanish (Spanish)",
    "es-ES": "Español (España)"
  },
  "TO": {
    "pt-BR": "a",
    "en-US": "to",
    "es-ES": "a"
  },
  "TO_DO": {
    "pt-BR": "To-Do",
    "en-US": "To-Do",
    "es-ES": "To-Do"
  },
  "WELCOME": {
    "pt-BR": "Seja bem-vindo(a)",
    "en-US": "Welcome to",
    "es-ES": "Bienvenido(a)"
  },
  "YES": {
    "pt-BR": "Sim",
    "en-US": "Yes",
    "es-ES": "Sí"
  },
  "NO_DATA_FOUND": {
    "pt-BR": "Nenhum dado encontrado!",
    "en-US": "No data found!",
    "es-ES": "¡No se encontraron datos!"
  },
  "SPACE": {
    "pt-BR": "Espaço",
    "en-US": "Space",
    "es-ES": "Espacio"
  },
  "MANAGE": {
    "pt-BR": "Gerenciar",
    "en-US": "Manage",
    "es-ES": "Gestionar"
  },
  "NAME": {
    "pt-BR": "Nome",
    "en-US": "Name",
    "es-ES": "Nombre"
  },
  "SPACE_SUCCESSFULLY_ACTIVATED": {
    "pt-BR": "Espaço ativado com sucesso!",
    "en-US": "Space successfully activated!",
    "es-ES": "¡Espacio activado correctamente!"
  },
  "SPACE_SUCCESSFULLY_DELETED": {
    "pt-BR": "Espaço excluído com sucesso!",
    "en-US": "Space successfully deleted!",
    "es-ES": "¡Espacio eliminado correctamente!"
  },
  "SPACE_SUCCESSFULLY_INACTIVATED": {
    "pt-BR": "Espaço inativado com sucesso!",
    "en-US": "Space successfully inactivated!",
    "es-ES": "¡Espacio desactivado correctamente!"
  },
  "SPACE_SUCCESSFULLY_UPDATED": {
    "pt-BR": "Espaço atualizado com sucesso!",
    "en-US": "Space successfully updated!",
    "es-ES": "¡Espacio actualizado correctamente!"
  },
  "SPACE_SUCCESSFULLY_CREATED": {
    "pt-BR": "Espaço criado com sucesso!",
    "en-US": "Space successfully created!",
    "es-ES": "¡Espacio creado correctamente!"
  },
  "SPACES": {
    "pt-BR": "Espaços",
    "en-US": "Spaces",
    "es-ES": "Espacios"
  },
  "INFORM_THE": {
    "pt-BR": "Informe o",
    "en-US": "Inform the",
    "es-ES": "Informar el"
  },
  "INFORM_THE_FEMALE": {
    "pt-BR": "Informe a",
    "en-US": "Inform the",
    "es-ES": "Informar la"
  },
  "WIDTH": {
    "pt-BR": "Largura",
    "en-US": "Width",
    "es-ES": "Ancho"
  },
  "HEIGHT": {
    "pt-BR": "Altura",
    "en-US": "Height",
    "es-ES": "Altura"
  },
  "SELECT_A": {
    "pt-BR": "Selecione um",
    "en-US": "Select a",
    "es-ES": "Seleccione un"
  },
  "MEDIA": {
    "pt-BR": "Mídia",
    "en-US": "Media",
    "es-ES": "Medios"
  },
  "MEDIAS": {
    "pt-BR": "Mídias",
    "en-US": "Medias",
    "es-ES": "Medios"
  },
  "DIMENSIONS": {
    "pt-BR": "Dimensões",
    "en-US": "Dimensions",
    "es-ES": "Dimensiones"
  },
  "ERROR_IN_THE_CODE": {
    "pt-BR": "Erro no código",
    "en-US": "Error in the code",
    "es-ES": "Error en el código"
  },
  "DURATION": {
    "pt-BR": "Duração",
    "en-US": "Duration",
    "es-ES": "Duración"
  },
  "START_DATE": {
    "pt-BR": "Data de início",
    "en-US": "Start date",
    "es-ES": "Fecha de inicio"
  },
  "END_DATE": {
    "pt-BR": "Data de término",
    "en-US": "End date",
    "es-ES": "Fecha de finalización"
  },
  "WEEK_ABBR_SUNDAY": {
    "pt-BR": "Dom",
    "en-US": "Sun",
    "es-ES": "Dom"
  },
  "WEEK_ABBR_MONDAY": {
    "pt-BR": "Seg",
    "en-US": "Mon",
    "es-ES": "Lun"
  },
  "WEEK_ABBR_TUESDAY": {
    "pt-BR": "Ter",
    "en-US": "Tue",
    "es-ES": "Mar"
  },
  "WEEK_ABBR_WEDNESDAY": {
    "pt-BR": "Qua",
    "en-US": "Wed",
    "es-ES": "Mie"
  },
  "WEEK_ABBR_THURSDAY": {
    "pt-BR": "Qui",
    "en-US": "Thu",
    "es-ES": "Jue"
  },
  "WEEK_ABBR_FRIDAY": {
    "pt-BR": "Sex",
    "en-US": "Fri",
    "es-ES": "Vie"
  },
  "WEEK_ABBR_SATURDAY": {
    "pt-BR": "Sáb",
    "en-US": "Sat",
    "es-ES": "Sab"
  },
  "WEEK": {
    "pt-BR": "Sem.",
    "en-US": "Week",
    "es-ES": "Sem."
  },
  "MONTH_ABBR_JANUARY": {
    "pt-BR": "Jan",
    "en-US": "Jan",
    "es-ES": "Ene"
  },
  "MONTH_ABBR_FEBRUARY": {
    "pt-BR": "Fev",
    "en-US": "Feb",
    "es-ES": "Feb"
  },
  "MONTH_ABBR_MARCH": {
    "pt-BR": "Mar",
    "en-US": "Mar",
    "es-ES": "Mar"
  },
  "MONTH_ABBR_APRIL": {
    "pt-BR": "Abr",
    "en-US": "Apr",
    "es-ES": "Abr"
  },
  "MONTH_ABBR_MAY": {
    "pt-BR": "Mai",
    "en-US": "May",
    "es-ES": "May"
  },
  "MONTH_ABBR_JUNE": {
    "pt-BR": "Jun",
    "en-US": "Jun",
    "es-ES": "Jun"
  },
  "MONTH_ABBR_JULY": {
    "pt-BR": "Jul",
    "en-US": "Jul",
    "es-ES": "Jul"
  },
  "MONTH_ABBR_AUGUST": {
    "pt-BR": "Ago",
    "en-US": "Aug",
    "es-ES": "Ago"
  },
  "MONTH_ABBR_SEPTEMBER": {
    "pt-BR": "Set",
    "en-US": "Sep",
    "es-ES": "Sep"
  },
  "MONTH_ABBR_OCTOBER": {
    "pt-BR": "Out",
    "en-US": "Oct",
    "es-ES": "Oct"
  },
  "MONTH_ABBR_NOVEMBER": {
    "pt-BR": "Nov",
    "en-US": "Nov",
    "es-ES": "Nov"
  },
  "MONTH_ABBR_DECEMBER": {
    "pt-BR": "Dez",
    "en-US": "Dec",
    "es-ES": "Dic"
  },
  "CHOOSE": {
    "pt-BR": "Escolha",
    "en-US": "Choose",
    "es-ES": "Elegir"
  },
  "WAIT": {
    "pt-BR": "Aguarde",
    "en-US": "Wait",
    "es-ES": "Espere"
  },
  "PRIORITIES": {
    "pt-BR": "Prioridades",
    "en-US": "Priorities",
    "es-ES": "Prioridades"
  },
  "WEIGHT": {
    "pt-BR": "Peso",
    "en-US": "Weight",
    "es-ES": "Peso"
  },
  "PRIORITY": {
    "pt-BR": "Prioridade",
    "en-US": "Priority",
    "es-ES": "Prioridade"
  },
  "CLIENT": {
    "pt-BR": "Cliente",
    "en-US": "Client",
    "es-ES": "Cliente"
  },
  "CLIENTS": {
    "pt-BR": "Clientes",
    "en-US": "Clients",
    "es-ES": "Clientes"
  },
  "APPOINTMENT": {
    "pt-BR": "Agendamento",
    "en-US": "Appointment",
    "es-ES": "Agendamiento"
  },
  "APPOINTMENTS": {
    "pt-BR": "Agendamentos",
    "en-US": "Appointments",
    "es-ES": "Agendamientos"
  },
  "PENDING": {
    "pt-BR": "Pendente",
    "en-US": "Pending",
    "es-ES": "Pendiente"
  },
  "CONFIRMED": {
    "pt-BR": "Confirmado",
    "en-US": "Confirmed",
    "es-ES": "Confirmado"
  },
  "IN_PROGRESS": {
    "pt-BR": "Em atendimento",
    "en-US": "In progress",
    "es-ES": "En atención"
  },
  "COMPLETED": {
    "pt-BR": "Finalizado",
    "en-US": "Completed",
    "es-ES": "Finalizado"
  },
  "CANCELED": {
    "pt-BR": "Cancelado",
    "en-US": "Canceled",
    "es-ES": "Cancelado"
  },
  "TIME": {
    "pt-BR": "Hora",
    "en-US": "Time",
    "es-ES": "Hora"
  },
  "STATUS": {
    "pt-BR": "Status",
    "en-US": "Status",
    "es-ES": "Estado"
  },
  "PERSONALIZACAO": {
    "pt-BR": "Personalização",
    "en-US": "Customization",
    "es-ES": "Personalización"
  },
  "PREVIEW_BUTTON_TOTEM": {
    "pt-BR": "Preview do botão no totem",
    "en-US": "Preview of the button on the totem",
    "es-ES": "Vista previa del botón en el tótem"
  },
  "PRIORITY_COLOR": {
    "pt-BR": "Cor da prioridade",
    "en-US": "Priority color",
    "es-ES": "Color prioritario"
  },
  "SERVICES_GROUPS": {
    "pt-BR": "Grupos de Atendimento",
    "en-US": "Service Groups",
    "es-ES": "Grupos de Apoyo"
  },
  "SERVICE_GROUP": {
    "pt-BR": "Grupo de Atendimento",
    "en-US": "Service Group",
    "es-ES": "Grupo de Apoyo"
  },
  "SERVICES_THIS_SERVICE_GROUP": {
    "pt-BR": "Serviços para este Grupo de Atendimento",
    "en-US": "Services for this Service Group",
    "es-ES": "Servicios para este Grupo de Apoyo"
  },
  "SERVICES": {
    "pt-BR": "Serviços",
    "en-US": "Services",
    "es-ES": "Servicios"
  },
  "SERVICE": {
    "pt-BR": "Serviço",
    "en-US": "Service",
    "es-ES": "Servicio"
  },
  "SERVICE_PRIORITIES": {
    "pt-BR": "Prioridades do serviço",
    "en-US": "Service priorities",
    "es-ES": "Prioridades del servicio"
  },
  "SERVICE_CANNOT_BE_ITS_OWN_PARENT": {
    "pt-BR": "Um serviço não pode ser seu próprio serviço superior.",
    "en-US": "A service cannot be its own parent.",
    "es-ES": "Un servicio no puede ser su propio servicio superior."
  },
  "SERVICE_NAME_MUST_BE_UNIQUE": {
    "pt-BR": "O nome do serviço deve ser único.",
    "en-US": "The service name must be unique.",
    "es-ES": "El nombre del servicio debe ser único."
  },
  "SERVICE_WEIGHT_MUST_BE_POSITIVE": {
    "pt-BR": "O peso do serviço deve ser um número positivo.",
    "en-US": "The service weight must be a positive number.",
    "es-ES": "El peso del servicio debe ser un número positivo."
  },
  "SERVICE_MAXIMUM_TIME_MUST_BE_POSITIVE": {
    "pt-BR": "O tempo máximo de atendimento do serviço deve ser um número positivo.",
    "en-US": "The service maximum time must be a positive number.",
    "es-ES": "El tiempo máximo de servicio debe ser un número positivo."
  },
  "SERVICE_PARENT_CYCLE_NOT_ALLOWED": {
    "pt-BR": "A hierarquia de serviços não pode conter ciclos.",
    "en-US": "The service hierarchy cannot contain cycles.",
    "es-ES": "La jerarquía de servicios no puede contener ciclos."
  },
  "PRIORITY_NAME_MUST_BE_UNIQUE": {
    "pt-BR": "O nome da prioridade deve ser único.",
    "en-US": "The priority name must be unique.",
    "es-ES": "El nombre de la prioridad debe ser único."
  },
  "RESOLUTION_NAME_MUST_BE_UNIQUE": {
    "pt-BR": "O nome da resolucao deve ser unico.",
    "en-US": "The resolution name must be unique.",
    "es-ES": "El nombre de la resolucion debe ser unico."
  },
  "SERVICE_GROUP_NAME_MUST_BE_UNIQUE": {
    "pt-BR": "O nome do grupo de atendimento deve ser unico.",
    "en-US": "The service group name must be unique.",
    "es-ES": "El nombre del grupo de atencion debe ser unico."
  },
  "LOCATION_NAME_MUST_BE_UNIQUE": {
    "pt-BR": "O nome do local deve ser unico.",
    "en-US": "The location name must be unique.",
    "es-ES": "El nombre del local debe ser unico."
  },
  "PRIORITY_WEIGHT_MUST_BE_POSITIVE": {
    "pt-BR": "O peso da prioridade deve ser um número positivo.",
    "en-US": "The priority weight must be a positive number.",
    "es-ES": "El peso de la prioridad debe ser un número positivo."
  },
  "EMPTY_REGISTERS_OF": {
    "pt-BR": "Nenhum registro de {0} cadastrado.",
    "en-US": "No records of {0} registered.",
    "es-ES": "No hay registros de {0} registrados."
  },
  "ACRONYM": {
    "pt-BR": "Sigla",
    "en-US": "Acronym",
    "es-ES": "Acrónimo"
  },
  "MAXIMUM_SERVICE_TIME": {
    "pt-BR": "Tempo máximo de atendimento (minutos)",
    "en-US": "Maximum service time (minutes)",
    "es-ES": "Tiempo máximo de servicio (minutos)"
  },
  "SUPERIOR_SERVICE": {
    "pt-BR": "Serviço superior",
    "en-US": "Superior service",
    "es-ES": "Servicio superior"
  },
  "PARENT_SERVICE": {
    "pt-BR": "Entidade de serviço superior",
    "en-US": "Parent service",
    "es-ES": "Entidad de servicio superior"
  },
  "SELECT_OPTION": {
    "pt-BR": "Selecione uma opção",
    "en-US": "Select an option",
    "es-ES": "Selecione uma opção"
  },
  "NONE": {
    "pt-BR": "Nenhum",
    "en-US": "None",
    "es-ES": "Ninguno"
  },
  "LOCATIONS": {
    "pt-BR": "Locais",
    "en-US": "Locations",
    "es-ES": "Ubicaciones"
  },
  "LOCATION": {
    "pt-BR": "Local",
    "en-US": "Local",
    "es-ES": "Local"
  },
  "RESOLUTIONS": {
    "pt-BR": "Resoluções",
    "en-US": "Resolutions",
    "es-ES": "Resoluciones"
  },
  "RESOLUTION": {
    "pt-BR": "Resolução",
    "en-US": "Resolution",
    "es-ES": "Resolución"
  },
  "RESOLUTION_REQUIRED_FOR_THIS_ACTION": {
    "pt-BR": "Resolução obrigatória para esta ação.",
    "en-US": "Resolution required for this action.",
    "es-ES": "Resolución requerida para esta acción."
  },
  "SERVICE_GROUPS_THIS_LOCATION": {
    "pt-BR": "Serviços para este Grupo de Atendimento",
    "en-US": "Services for this Customer Service Group",
    "es-ES": "Servicios para este Grupo de Atención al Cliente"
  },
  "AUTHORIZATION_NOT_FOUND": {
    "pt-BR": "Autorização não encontrada",
    "en-US": "Authorization not found",
    "es-ES": "Autorización no encontrada"
  },
  "INVALID_TOKEN": {
    "pt-BR": "Token Inválido",
    "en-US": "Invalid Token",
    "es-ES": "Token no válido"
  },
  "USER_NOT_ALLOWED": {
    "pt-BR": "Usuário não possui permissões válidas.",
    "en-US": "The user does not have valid permissions.",
    "es-ES": "El usuario no tiene permisos válidos."
  },
  "ACCESS_DENIED_INSUFFICIENT_PERMISSION": {
    "pt-BR": "Acesso negado: permissão insuficiente",
    "en-US": "Access denied: insufficient permission",
    "es-ES": "Acceso denegado: permiso insuficiente"
  },
  "LOCATION_ID_REQUIRED": {
    "pt-BR": "O ID do local é obrigatório.",
    "en-US": "Location ID is required.",
    "es-ES": "Se requiere el ID de la ubicación."
  },
  "ENTITY_NOT_FOUND": {
    "pt-BR": "{0} não encontrada",
    "en-US": "{0} not found",
    "es-ES": "{0} no encontrada"
  },
  "ENTITY_ID_NOT_FOUND": {
    "pt-BR": "{0} não foi encontrado",
    "en-US": "{0} was not found.",
    "es-ES": "{0} no se encontró"
  },
  "UNKNOWN_OPERATION_ERROR": {
    "pt-BR": "Uma operação desconhecida foi tentada.",
    "en-US": "An unknown operation was attempted.",
    "es-ES": "Se intentó llevar a cabo una operación desconocida."
  },
  "EMPTY_ATTENDANCE_QUEUE": {
    "pt-BR": "Nenhuma senha na fila para atendimento.",
    "en-US": "No one in the queue for service.",
    "es-ES": "No hay nadie en la cola para ser atendido."
  },
  "ATTENDANCE_STATUS_CHANGE_ERROR": {
    "pt-BR": "Erro na alteração de status do atendimento.",
    "en-US": "Error changing attendance status.",
    "es-ES": "Error al cambiar el estado de la atención."
  },
  "INVALID_ATTENDANCE_TRANSITION": {
    "pt-BR": "Transição de atendimento inválida.",
    "en-US": "Invalid attendance transition.",
    "es-ES": "Transición de atención inválida."
  },
  "ATTENDANCES": {
    "pt-BR": "Atendimentos",
    "en-US": "Attendances",
    "es-ES": "Asistencias"
  },
  "ATTENDANCE": {
    "pt-BR": "Atendimento",
    "en-US": "Attendance",
    "es-ES": "Asistencia"
  },
  "ATTENDANTS": {
    "pt-BR": "Atendentes",
    "en-US": "Attendants",
    "es-ES": "Asistentes"
  },
  "ATTENDANT": {
    "pt-BR": "Atendente",
    "en-US": "Attendant",
    "es-ES": "Asistente"
  },
  "CALL_NEXT": {
    "pt-BR": "Chamar o próximo",
    "en-US": "Call next",
    "es-ES": "Llamar al siguiente"
  },
  "CALL_AGAIN": {
    "pt-BR": "Chamar novamente",
    "en-US": "Call again",
    "es-ES": "Llamar de nuevo"
  },
  "START_ATTENDANCE": {
    "pt-BR": "Iniciar atendimento",
    "en-US": "Start attendance",
    "es-ES": "Iniciar atención"
  },
  "END_ATTENDANCE": {
    "pt-BR": "Encerrar atendimento",
    "en-US": "End attendance",
    "es-ES": "Finalizar atención"
  },
  "FILL_FORWARDING_DATA": {
    "pt-BR": "Preencha os dados do encaminhamento",
    "en-US": "Fill in the forwarding details",
    "es-ES": "Complete los datos del reenvío"
  },
  "FINISH_CURRENT_ATTENDANCE": {
    "pt-BR": "Finalize o atendimento atual",
    "en-US": "Finish the current attendance",
    "es-ES": "Finalice la atención actual"
  },
  "FORWARD_ATTENDANCE": {
    "pt-BR": "Encaminhar",
    "en-US": "Forward",
    "es-ES": "Reenviar"
  },
  "CONFIRM_FORWARD_ATTENDANCE": {
    "pt-BR": "Confirmar encaminhamento",
    "en-US": "Confirm forwarding",
    "es-ES": "Confirmar reenvío"
  },
  "FORWARD_ATTENDANCE_TARGET_REQUIRED": {
    "pt-BR": "Selecione o grupo e o serviço de destino para encaminhar.",
    "en-US": "Select the target group and service to forward.",
    "es-ES": "Seleccione el grupo y el servicio de destino para reenviar."
  },
  "FORWARDING_CREATES_NEW_ATTENDANCE": {
    "pt-BR": "O atendimento atual será encerrado e um novo atendimento será criado no mesmo ticket.",
    "en-US": "The current attendance will be finished and a new attendance will be created on the same ticket.",
    "es-ES": "La atención actual se finalizará y se creará una nueva atención en el mismo ticket."
  },
  "USE_FIELDS_BELOW_TO_REGISTER_RESOLUTION": {
    "pt-BR": "Use os campos abaixo para registrar a resolução do atendimento.",
    "en-US": "Use the fields below to record the attendance resolution.",
    "es-ES": "Use los campos a continuación para registrar la resolución de la atención."
  },
  "CANCEL_FORWARDING": {
    "pt-BR": "Cancelar encaminhamento",
    "en-US": "Cancel forwarding",
    "es-ES": "Cancelar reenvío"
  },
  "TICKET_HISTORY": {
    "pt-BR": "Histórico do ticket",
    "en-US": "Ticket history",
    "es-ES": "Historial del ticket"
  },
  "NO_SERVICE": {
    "pt-BR": "Sem serviço",
    "en-US": "No service",
    "es-ES": "Sin servicio"
  },
  "TICKET_WAS_CALLED_AT": {
    "pt-BR": "Chamado em",
    "en-US": "Called at",
    "es-ES": "Llamado en"
  },
  "ATTENDANCE_STARTED_AT": {
    "pt-BR": "Iniciado em",
    "en-US": "Started at",
    "es-ES": "Iniciado en"
  },
  "ATTENDANCE_ENDED_AT": {
    "pt-BR": "Encerrado em",
    "en-US": "Ended at",
    "es-ES": "Finalizado en"
  },
  "ATTENDANCE_WAITING": {
    "pt-BR": "Aguardando",
    "en-US": "Waiting",
    "es-ES": "En espera"
  },
  "ATTENDANCE_CALLED": {
    "pt-BR": "Chamado",
    "en-US": "Called",
    "es-ES": "Llamado"
  },
  "ATTENDANCE_IN_PROGRESS": {
    "pt-BR": "Em atendimento",
    "en-US": "In attendance",
    "es-ES": "En atención"
  },
  "NO_SHOW_ON_CALL": {
    "pt-BR": "Não compareceu na chamada",
    "en-US": "No show on call",
    "es-ES": "No se presentó en el llamado"
  },
  "NO_SHOW_DURING_ATTENDANCE": {
    "pt-BR": "Não compareceu durante o atendimento",
    "en-US": "No show during attendance",
    "es-ES": "No se presentó durante la atención"
  },
  "TRIAGE_ERROR": {
    "pt-BR": "Erro de triagem",
    "en-US": "Triage error",
    "es-ES": "Error de triaje"
  },
  "ATTENDANCE_FINISHED": {
    "pt-BR": "Finalizado",
    "en-US": "Finished",
    "es-ES": "Finalizado"
  },
  "ATTENDANCE_FORWARDED": {
    "pt-BR": "Encaminhado",
    "en-US": "Forwarded",
    "es-ES": "Reenviado"
  },
  "ATTENDANCES_FOUND": {
    "pt-BR": "atendimentos encontrados",
    "en-US": "attendances found",
    "es-ES": "atenciones encontradas"
  },
  "NO_SHOW": {
    "pt-BR": "Não compareceu",
    "en-US": "No show",
    "es-ES": "No se presentó"
  },
  "CANCELLATIONS": {
    "pt-BR": "Cancelamentos",
    "en-US": "Cancellations",
    "es-ES": "Cancelaciones"
  },
  "NO_PRIORITY": {
    "pt-BR": "Sem prioridade",
    "en-US": "No priority",
    "es-ES": "Sin prioridad"
  },
  "RESUME_ATTENDANCE": {
    "pt-BR": "Retomar atendimento",
    "en-US": "Resume attendance",
    "es-ES": "Reanudar atención"
  },
  "REMOVE": {
    "pt-BR": "Remover",
    "en-US": "Remove",
    "es-ES": "Eliminar"
  },
  "BOOTH": {
    "pt-BR": "Guichê",
    "en-US": "Booth",
    "es-ES": "Ventanilla"
  },
  "TARGET_SERVICE_GROUP": {
    "pt-BR": "Grupo de destino",
    "en-US": "Target group",
    "es-ES": "Grupo de destino"
  },
  "SELECT_A_SERVICE_GROUP": {
    "pt-BR": "Selecione um grupo",
    "en-US": "Select a group",
    "es-ES": "Seleccione un grupo"
  },
  "SELECT_TARGET_SERVICE_GROUP": {
    "pt-BR": "Selecione o grupo de destino.",
    "en-US": "Select the target group.",
    "es-ES": "Seleccione el grupo de destino."
  },
  "TARGET_SERVICE": {
    "pt-BR": "Serviço de destino",
    "en-US": "Target service",
    "es-ES": "Servicio de destino"
  },
  "SELECT_A_SERVICE": {
    "pt-BR": "Selecione um serviço",
    "en-US": "Select a service",
    "es-ES": "Seleccione un servicio"
  },
  "SELECT_TARGET_SERVICE": {
    "pt-BR": "Selecione o serviço de destino.",
    "en-US": "Select the target service.",
    "es-ES": "Seleccione el servicio de destino."
  },
  "INITIAL_OBSERVATION_FOR_NEW_ATTENDANCE": {
    "pt-BR": "Observação inicial do novo atendimento",
    "en-US": "Initial observation for the new attendance",
    "es-ES": "Observación inicial de la nueva atención"
  },
  "SHOW_PANEL": {
    "pt-BR": "Mostrar painel",
    "en-US": "Show panel",
    "es-ES": "Mostrar panel"
  },
  "CLICK_CALL_NEXT_TO_SELECT_TICKET": {
    "pt-BR": "Clique em Chamar o próximo para selecionar uma senha",
    "en-US": "Click Call next to select a ticket",
    "es-ES": "Haz clic en Llamar al siguiente para seleccionar un ticket"
  },
  "NEXT_TICKETS_IN_QUEUE": {
    "pt-BR": "Próximas senhas na fila",
    "en-US": "Next tickets in queue",
    "es-ES": "Próximos tickets en la cola"
  },
  "LOADING_ATTENDANCES": {
    "pt-BR": "Carregando atendimentos...",
    "en-US": "Loading attendances...",
    "es-ES": "Cargando atenciones..."
  },
  "PREVIOUS": {
    "pt-BR": "Anterior",
    "en-US": "Previous",
    "es-ES": "Anterior"
  },
  "NEXT": {
    "pt-BR": "Próximo",
    "en-US": "Next",
    "es-ES": "Siguiente"
  },
  "PAGE": {
    "pt-BR": "Página",
    "en-US": "Page",
    "es-ES": "Página"
  },
  "SERVICE_GROUPS_THIS_ATTENDANT": {
    "pt-BR": "Grupos de Atendimento para este Atendente",
    "en-US": "Service Groups for this Attendant",
    "es-ES": "Grupos de servicio para este Asistente"
  },
  "SERVICES_PROVIDED": {
    "pt-BR": "Serviços prestados",
    "en-US": "Services provided",
    "es-ES": "Servicios prestados"
  },
  "SERVICE_ID_REQUIRED": {
    "pt-BR": "O ID do serviço é obrigatório para gerar o número da senha.",
    "en-US": "Service ID is required to generate the ticket number.",
    "es-ES": "Se requiere el ID del servicio para generar el número del ticket."
  },
  "SERVICE_ACRONYM_REQUIRED": {
    "pt-BR": "A sigla do serviço é obrigatória para gerar o número da senha.",
    "en-US": "Service acronym is required to generate the ticket number.",
    "es-ES": "Se requiere la sigla del servicio para generar el número del ticket."
  },
  "TICKET_NUMBER_GENERATION_FAILED": {
    "pt-BR": "Não foi possível gerar um número de senha único.",
    "en-US": "Could not generate a unique ticket number.",
    "es-ES": "No se pudo generar un número de ticket único."
  },
  "UNASSIGNED": {
    "pt-BR": "Não atribuído",
    "en-US": "Unassigned",
    "es-ES": "Sin asignar"
  },
  "NO_STATUS": {
    "pt-BR": "Sem status",
    "en-US": "No status",
    "es-ES": "Sin estado"
  },
  "OBSERVATION": {
    "pt-BR": "Observação",
    "en-US": "Observation",
    "es-ES": "Observación"
  },
  "TICKET_LABEL": {
    "pt-BR": "Senha",
    "en-US": "Ticket",
    "es-ES": "Ticket"
  },
  "OPEN_SIDE_PANEL": {
    "pt-BR": "Abrir painel lateral",
    "en-US": "Open side panel",
    "es-ES": "Abrir panel lateral"
  },
  "COLLAPSE_SIDE_PANEL": {
    "pt-BR": "Recolher painel lateral",
    "en-US": "Collapse side panel",
    "es-ES": "Contraer panel lateral"
  },
  "NO_TICKET_IN_FOCUS": {
    "pt-BR": "Nenhuma senha em foco",
    "en-US": "No ticket in focus",
    "es-ES": "Ningún ticket en foco"
  },
  "LAST_MOVEMENT": {
    "pt-BR": "Última movimentação",
    "en-US": "Last movement",
    "es-ES": "Último movimiento"
  },
  "SELECT_A_TICKET_TO_TRACK": {
    "pt-BR": "Selecione uma senha para acompanhar",
    "en-US": "Select a ticket to track",
    "es-ES": "Seleccione un ticket para seguir"
  },
  "ATTENDANCE_DURATION": {
    "pt-BR": "Tempo em atendimento",
    "en-US": "Time in attendance",
    "es-ES": "Tiempo en atención"
  },
  "IDLE_TIME": {
    "pt-BR": "Tempo ocioso",
    "en-US": "Idle time",
    "es-ES": "Tiempo ocioso"
  },
  "ATTENDANCE_IN_PROGRESS_HINT": {
    "pt-BR": "Atendimento em andamento",
    "en-US": "Attendance in progress",
    "es-ES": "Atención en curso"
  },
  "WAITING_FOR_NEW_ATTENDANCE": {
    "pt-BR": "Aguardando novo atendimento",
    "en-US": "Waiting for a new attendance",
    "es-ES": "Esperando una nueva atención"
  },
  "PEOPLE_WAITING": {
    "pt-BR": "pessoas aguardando",
    "en-US": "people waiting",
    "es-ES": "personas esperando"
  },
  "CURRENT_BOOTH_QUEUE": {
    "pt-BR": "Fila atual do guichê",
    "en-US": "Current booth queue",
    "es-ES": "Fila actual de la ventanilla"
  },
  "NO_QUEUE_AT_THE_MOMENT": {
    "pt-BR": "Sem fila no momento",
    "en-US": "No queue at the moment",
    "es-ES": "Sin fila en este momento"
  },
  "NO_QUEUE": {
    "pt-BR": "Sem fila",
    "en-US": "No queue",
    "es-ES": "Sin fila"
  },
  "CALLED_TICKETS": {
    "pt-BR": "chamados",
    "en-US": "called",
    "es-ES": "llamados"
  },
  "NO_SHOW_TICKETS": {
    "pt-BR": "não compareceram",
    "en-US": "no-shows",
    "es-ES": "no se presentaron"
  },
  "QUEUE_HEALTH": {
    "pt-BR": "Saúde da fila",
    "en-US": "Queue health",
    "es-ES": "Salud de la fila"
  },
  "VIEW_TICKET_HISTORY": {
    "pt-BR": "Ver histórico do ticket",
    "en-US": "View ticket history",
    "es-ES": "Ver historial del ticket"
  },
  "OPERATIONAL_DATA": {
    "pt-BR": "Dados operacionais",
    "en-US": "Operational data",
    "es-ES": "Datos operativos"
  },
  "AVERAGE_WAIT_TIME": {
    "pt-BR": "Tempo médio de espera",
    "en-US": "Average wait time",
    "es-ES": "Tiempo medio de espera"
  },
  "MOST_DELAYED_SERVICE": {
    "pt-BR": "Serviço com maior atraso",
    "en-US": "Most delayed service",
    "es-ES": "Servicio con mayor retraso"
  },
  "AVERAGE_ATTENDANCE_TIME": {
    "pt-BR": "Tempo médio do atendimento",
    "en-US": "Average attendance time",
    "es-ES": "Tiempo medio de atención"
  },
  "TOTAL_ATTENDANCE_TIME": {
    "pt-BR": "Tempo total em atendimento",
    "en-US": "Total attendance time",
    "es-ES": "Tiempo total en atención"
  },
  "ACCOUNT": {
    "pt-BR": "Minha Conta",
    "en-US": "My Account",
    "es-ES": "Mi Cuenta"
  },
  "HELP": {
    "pt-BR": "Ajuda",
    "en-US": "Help",
    "es-ES": "Ayuda"
  },
  "HELPER": {
    "pt-BR": "Ajuda",
    "en-US": "Helper",
    "es-ES": "Ayudante"
  },
  "LOGOUT": {
    "pt-BR": "Sair",
    "en-US": "Logout",
    "es-ES": "Cerrar sesión"
  },
  "REPORTS": {
    "pt-BR": "Relatórios",
    "en-US": "Reports",
    "es-ES": "Informes"
  },
  "PERFORMANCE": {
    "pt-BR": "Desempenho",
    "en-US": "Performance",
    "es-ES": "Rendimiento"
  },
  "ATTENDANCE_HEATMAP": {
    "pt-BR": "Heatmap dia x hora",
    "en-US": "Day x hour heatmap",
    "es-ES": "Mapa de calor dia x hora"
  },
  "ATTENDANCES_PER_HOUR": {
    "pt-BR": "Atendimentos por hora",
    "en-US": "Attendances per hour",
    "es-ES": "Atenciones por hora"
  },
  "ATTENDANCES_BY_ATTENDANT": {
    "pt-BR": "Atendimentos por atendente",
    "en-US": "Attendances by attendant",
    "es-ES": "Atenciones por asistente"
  },
  "ATTENDANCES_PER_MONTH": {
    "pt-BR": "Atendimentos por mês",
    "en-US": "Attendances per month",
    "es-ES": "Atenciones por mes"
  },
  "ATTENDANCES_PER_DAY": {
    "pt-BR": "Atendimentos por dia",
    "en-US": "Attendances per day",
    "es-ES": "Atenciones por dia"
  },
  "MOST_REQUESTED_SERVICES": {
    "pt-BR": "Serviços mais solicitados",
    "en-US": "Most requested services",
    "es-ES": "Servicios más solicitados"
  },
  "PRIORITY_DISTRIBUTION": {
    "pt-BR": "Distribuição de prioridades",
    "en-US": "Priority distribution",
    "es-ES": "Distribución de prioridades"
  },
  "NO_SHOW_AND_CANCELLATIONS": {
    "pt-BR": "Não compareceu",
    "en-US": "No show",
    "es-ES": "No se presentó"
  },
  "QUEUE_EVOLUTION": {
    "pt-BR": "Evolução da fila",
    "en-US": "Queue evolution",
    "es-ES": "Evolución de la fila"
  },
  "PEOPLE_IN_QUEUE": {
    "pt-BR": "Pessoas na fila",
    "en-US": "People in queue",
    "es-ES": "Personas en la fila"
  },
  "AVERAGE_TIME": {
    "pt-BR": "Tempo médio",
    "en-US": "Average time",
    "es-ES": "Tiempo promedio"
  },
  "DASHBOARD": {
    "pt-BR": "Dashboard",
    "en-US": "Dashboard",
    "es-ES": "Dashboard"
  },
  "FILTERS": {
    "pt-BR": "Filtros",
    "en-US": "Filters",
    "es-ES": "Filtros"
  },
  "PERIOD_GROUPING": {
    "pt-BR": "Agrupamento por período",
    "en-US": "Period grouping",
    "es-ES": "Agrupación por período"
  },
  "GROUP_BY_DAY": {
    "pt-BR": "Por dia",
    "en-US": "By day",
    "es-ES": "Por día"
  },
  "GROUP_BY_WEEK": {
    "pt-BR": "Por semana",
    "en-US": "By week",
    "es-ES": "Por semana"
  },
  "GROUP_BY_MONTH": {
    "pt-BR": "Por mês",
    "en-US": "By month",
    "es-ES": "Por mes"
  },
  "ORDERING": {
    "pt-BR": "Ordenação",
    "en-US": "Ordering",
    "es-ES": "Ordenación"
  },
  "ASCENDING": {
    "pt-BR": "Ascendente",
    "en-US": "Ascending",
    "es-ES": "Ascendente"
  },
  "DESCENDING": {
    "pt-BR": "Descendente",
    "en-US": "Descending",
    "es-ES": "Descendente"
  },
  "CLEAR_FILTERS": {
    "pt-BR": "Limpar filtros",
    "en-US": "Clear filters",
    "es-ES": "Limpiar filtros"
  },
  "EXPORT_CSV": {
    "pt-BR": "Exportar CSV",
    "en-US": "Export CSV",
    "es-ES": "Exportar CSV"
  },
  "COMING_SOON": {
    "pt-BR": "Em breve",
    "en-US": "Coming soon",
    "es-ES": "Próximamente"
  },
  "NO_ATTENDANCES_FOUND": {
    "pt-BR": "Nenhum atendimento encontrado para os filtros informados.",
    "en-US": "No attendances were found for the selected filters.",
    "es-ES": "No se encontraron atenciones para los filtros seleccionados."
  },
  "ALL": {
    "pt-BR": "Todos",
    "en-US": "All",
    "es-ES": "Todos"
  },
  "SELECT_AUTHENTICATED_USER": {
    "pt-BR": "Selecione o usuário autenticado para enviar o ID e o nome, ou digite um nome.",
    "en-US": "Select the authenticated user to send the ID and name, or type a name.",
    "es-ES": "Seleccione el usuario autenticado para enviar el ID y el nombre, o escriba un nombre."
  },
  "SELECT_SERVICE_GROUP_TO_ENABLE_SERVICES_FOR_THIS_ATTENDANT": {
    "pt-BR": "Selecione um grupo de serviços para habilitar os serviços atendidos por este atendente.",
    "en-US": "Select a service group to enable the services attended by this attendant.",
    "es-ES": "Seleccione un grupo de servicios para habilitar los servicios atendidos por este asistente."
  },
  "SERVICE_IN_USE_DEACTIVATE_INSTEAD": {
    "pt-BR": "Este serviço está em uso. Desative-o em vez de excluí-lo.",
    "en-US": "This service is in use. Deactivate it instead of deleting it.",
    "es-ES": "Este servicio está en uso. Desactívelo en lugar de eliminarlo."
  },
  "PRIORITY_IN_USE_DEACTIVATE_INSTEAD": {
    "pt-BR": "Esta prioridade está em uso. Desative-a em vez de excluí-la.",
    "en-US": "This priority is in use. Deactivate it instead of deleting it.",
    "es-ES": "Esta prioridad está en uso. Desactívela en lugar de eliminarla."
  },
  "SERVICE_GROUP_IN_USE_DEACTIVATE_INSTEAD": {
    "pt-BR": "Este grupo de atendimento está em uso. Desative-o em vez de excluí-lo.",
    "en-US": "This service group is in use. Deactivate it instead of deleting it.",
    "es-ES": "Este grupo de atención está en uso. Desactívelo en lugar de eliminarlo."
  },
  "HEALTHCHECK": {
    "pt-BR": "Healthcheck",
    "en-US": "Health check",
    "es-ES": "Health check"
  },
  "OPEN_HEALTHCHECK_DETAILS": {
    "pt-BR": "Abrir detalhes do healthcheck",
    "en-US": "Open health check details",
    "es-ES": "Abrir detalles del health check"
  },
  "SYSTEM_HEALTHCHECK": {
    "pt-BR": "Healthcheck do sistema",
    "en-US": "System health check",
    "es-ES": "Health check del sistema"
  },
  "SUMMARY": {
    "pt-BR": "Resumo",
    "en-US": "Summary",
    "es-ES": "Resumen"
  },
  "RECOMMENDED_ADJUSTMENTS": {
    "pt-BR": "Ajustes recomendados",
    "en-US": "Recommended fixes",
    "es-ES": "Ajustes recomendados"
  },
  "EVERYTHING_OK_HERE": {
    "pt-BR": "Tudo certo por aqui",
    "en-US": "Everything looks good",
    "es-ES": "Todo bien por aqui"
  },
  "HEALTHCHECK_ISSUES_SUMMARY": {
    "pt-BR": "Esses pontos podem impedir a fila de funcionar como esperado. Revise cada item abaixo.",
    "en-US": "These issues may prevent the queue from working as expected. Review each item below.",
    "es-ES": "Estos puntos pueden impedir que la fila funcione como se espera. Revise cada elemento a continuación."
  },
  "HEALTHCHECK_OK_SUMMARY": {
    "pt-BR": "Nenhum problema de configuração foi encontrado na última verificação.",
    "en-US": "No configuration issues were found in the latest check.",
    "es-ES": "No se encontraron problemas de configuración en la última verificación."
  },
  "PROBLEMS_FOUND": {
    "pt-BR": "Problemas encontrados",
    "en-US": "Problems found",
    "es-ES": "Problemas encontrados"
  },
  "CATEGORY_WITH_ALERT": {
    "pt-BR": "categoria com alerta",
    "en-US": "category with alert",
    "es-ES": "categoria con alerta"
  },
  "CATEGORIES_WITH_ALERT": {
    "pt-BR": "categorias com alerta",
    "en-US": "categories with alert",
    "es-ES": "categorias con alerta"
  },
  "LAST_CHECK": {
    "pt-BR": "Última verificação",
    "en-US": "Last check",
    "es-ES": "Última verificación"
  },
  "NO_HEALTHCHECK_ISSUES_FOUND": {
    "pt-BR": "Nenhum problema encontrado nas verificações configuradas.",
    "en-US": "No issues were found in the configured checks.",
    "es-ES": "No se encontraron problemas en las verificaciones configuradas."
  },
  "HOW_TO_FIX": {
    "pt-BR": "Como resolver",
    "en-US": "How to fix",
    "es-ES": "Como resolver"
  },
  "LOADING_CHECKS": {
    "pt-BR": "Carregando verificações",
    "en-US": "Loading checks",
    "es-ES": "Cargando verificaciones"
  },
  "NO_DATA": {
    "pt-BR": "Sem dados",
    "en-US": "No data",
    "es-ES": "Sin datos"
  },
  "NO_ISSUES_FOUND": {
    "pt-BR": "Nenhum problema encontrado",
    "en-US": "No issues found",
    "es-ES": "No se encontraron problemas"
  },
  "CLICK_TO_VIEW_DETAILS_AND_FIX": {
    "pt-BR": "Clique para ver detalhes e como corrigir",
    "en-US": "Click to view details and fixes",
    "es-ES": "Haga clic para ver los detalles y cómo corregir"
  },
  "CLICK_TO_REVIEW_CHECKS": {
    "pt-BR": "Clique para revisar as verificações",
    "en-US": "Click to review checks",
    "es-ES": "Haga clic para revisar las verificaciones"
  },
  "ATTENDANTS_WITH_INVALID_CONFIGURATION": {
    "pt-BR": "Atendentes sem configuração válida",
    "en-US": "Attendants without valid configuration",
    "es-ES": "Atendentes sin configuración válida"
  },
  "ATTENDANTS_INVALID_CONFIGURATION_DESCRIPTION": {
    "pt-BR": "Atendentes precisam ter grupo de atendimento e serviços disponíveis para receber senhas.",
    "en-US": "Attendants must have a service group and available services to receive tickets.",
    "es-ES": "Los atendentes deben tener un grupo de atención y servicios disponibles para recibir turnos."
  },
  "LOCATIONS_WITH_INVALID_CONFIGURATION": {
    "pt-BR": "Locais sem configuração válida",
    "en-US": "Locations without valid configuration",
    "es-ES": "Ubicaciones sin configuración válida"
  },
  "LOCATIONS_INVALID_CONFIGURATION_DESCRIPTION": {
    "pt-BR": "Locais precisam estar vinculados a grupos de atendimento com serviços ativos.",
    "en-US": "Locations must be linked to service groups with active services.",
    "es-ES": "Las ubicaciones deben estar vinculadas a grupos de atención con servicios activos."
  },
  "ORPHAN_ATTENDANCES_IN_QUEUE": {
    "pt-BR": "Atendimentos órfãos na fila",
    "en-US": "Orphan attendances in queue",
    "es-ES": "Atenciones huérfanas en la fila"
  },
  "ORPHAN_ATTENDANCES_IN_QUEUE_DESCRIPTION": {
    "pt-BR": "Esses atendimentos não conseguem ser exibidos corretamente na fila porque faltam vínculos compatíveis entre grupo, local e atendente.",
    "en-US": "These attendances cannot be displayed correctly in the queue because compatible links between group, location, and attendant are missing.",
    "es-ES": "Estas atenciones no pueden mostrarse correctamente en la fila porque faltan vínculos compatibles entre grupo, ubicación y atendente."
  },
  "SERVICE_GROUPS_WITHOUT_SERVICES": {
    "pt-BR": "Grupos de atendimento sem serviços",
    "en-US": "Service groups without services",
    "es-ES": "Grupos de atención sin servicios"
  },
  "SERVICE_GROUPS_WITHOUT_SERVICES_DESCRIPTION": {
    "pt-BR": "Sem serviços vinculados, o grupo não consegue participar corretamente das regras da fila.",
    "en-US": "Without linked services, the group cannot properly participate in the queue rules.",
    "es-ES": "Sin servicios vinculados, el grupo no puede participar correctamente en las reglas de la fila."
  },
  "PRIORITIES_WITH_DUPLICATE_WEIGHT": {
    "pt-BR": "Prioridades com peso duplicado",
    "en-US": "Priorities with duplicate weight",
    "es-ES": "Prioridades con peso duplicado"
  },
  "PRIORITIES_WITH_DUPLICATE_WEIGHT_DESCRIPTION": {
    "pt-BR": "Pesos repetidos podem comprometer a ordenação esperada da fila.",
    "en-US": "Repeated weights may compromise the expected queue ordering.",
    "es-ES": "Los pesos repetidos pueden comprometer el orden esperado de la fila."
  },
  "LINKED_GROUPS": {
    "pt-BR": "Grupos vinculados",
    "en-US": "Linked groups",
    "es-ES": "Grupos vinculados"
  },
  "NO_LINKED_GROUPS": {
    "pt-BR": "Sem grupos vinculados",
    "en-US": "No linked groups",
    "es-ES": "Sin grupos vinculados"
  },
  "NOT_INFORMED": {
    "pt-BR": "Não informados",
    "en-US": "Not informed",
    "es-ES": "No informados"
  },
  "LINKED_LOCATION": {
    "pt-BR": "local vinculado",
    "en-US": "linked location",
    "es-ES": "ubicación vinculada"
  },
  "LINKED_LOCATIONS": {
    "pt-BR": "locais vinculados",
    "en-US": "linked locations",
    "es-ES": "ubicaciones vinculadas"
  },
  "LINKED_ATTENDANT": {
    "pt-BR": "atendente vinculado",
    "en-US": "linked attendant",
    "es-ES": "atendente vinculado"
  },
  "LINKED_ATTENDANTS": {
    "pt-BR": "atendentes vinculados",
    "en-US": "linked attendants",
    "es-ES": "atendentes vinculados"
  },
  "NO_SERVICE_GROUP_LINKED": {
    "pt-BR": "Nenhum grupo de atendimento vinculado.",
    "en-US": "No service group linked.",
    "es-ES": "No hay ningún grupo de atención vinculado."
  },
  "LINKED_GROUPS_WITHOUT_AVAILABLE_SERVICES": {
    "pt-BR": "Os grupos vinculados não possuem serviços disponíveis.",
    "en-US": "The linked groups do not have available services.",
    "es-ES": "Los grupos vinculados no tienen servicios disponibles."
  },
  "ATTENDANT_LINK_AT_LEAST_ONE_SERVICE_GROUP": {
    "pt-BR": "Abra o cadastro do atendente e vincule pelo menos um grupo de atendimento.",
    "en-US": "Open the attendant record and link at least one service group.",
    "es-ES": "Abra el registro del atendente y vincule al menos un grupo de atención."
  },
  "ATTENDANT_REVIEW_GROUPS_AND_ACTIVE_SERVICES": {
    "pt-BR": "Revise os grupos vinculados ao atendente e garanta que eles tenham serviços ativos.",
    "en-US": "Review the attendant's linked groups and make sure they have active services.",
    "es-ES": "Revise los grupos vinculados al atendente y asegúrese de que tengan servicios activos."
  },
  "LOCATION_LINK_AT_LEAST_ONE_SERVICE_GROUP": {
    "pt-BR": "Abra o cadastro do local e vincule pelo menos um grupo de atendimento.",
    "en-US": "Open the location record and link at least one service group.",
    "es-ES": "Abra el registro de la ubicación y vincule al menos un grupo de atención."
  },
  "LOCATION_REVIEW_GROUPS_AND_ACTIVE_SERVICES": {
    "pt-BR": "Revise os grupos vinculados ao local e garanta que eles tenham serviços ativos.",
    "en-US": "Review the location's linked groups and make sure they have active services.",
    "es-ES": "Revise los grupos vinculados a la ubicación y asegúrese de que tengan servicios activos."
  },
  "NO_COMPATIBLE_LOCATION_WITH_GROUP": {
    "pt-BR": "Nenhum local compatível com o grupo deste atendimento.",
    "en-US": "No location is compatible with this attendance group.",
    "es-ES": "Ninguna ubicación es compatible con el grupo de esta atención."
  },
  "NO_ATTENDANT_LINKED_TO_GROUP": {
    "pt-BR": "Nenhum atendente vinculado ao grupo deste atendimento.",
    "en-US": "No attendant is linked to this attendance group.",
    "es-ES": "Ningún atendente está vinculado al grupo de esta atención."
  },
  "GROUP_ATTENDANTS_NOT_ENABLED_FOR_SERVICES": {
    "pt-BR": "Os atendentes do grupo não estão habilitados para os serviços deste atendimento.",
    "en-US": "The group's attendants are not enabled for this attendance services.",
    "es-ES": "Los atendentes del grupo no están habilitados para los servicios de esta atención."
  },
  "LINK_GROUP_TO_AT_LEAST_ONE_ACTIVE_LOCATION": {
    "pt-BR": "Vincule esse grupo de atendimento a pelo menos um local ativo para que a fila consiga exibi-lo.",
    "en-US": "Link this service group to at least one active location so the queue can display it.",
    "es-ES": "Vincule este grupo de atención a al menos una ubicación activa para que la fila pueda mostrarlo."
  },
  "LINK_AT_LEAST_ONE_ATTENDANT_TO_GROUP": {
    "pt-BR": "Vincule pelo menos um atendente a esse grupo de atendimento.",
    "en-US": "Link at least one attendant to this service group.",
    "es-ES": "Vincule al menos un atendente a este grupo de atención."
  },
  "ENABLE_AT_LEAST_ONE_SERVICE_FOR_GROUP_ATTENDANTS": {
    "pt-BR": "No cadastro dos atendentes desse grupo, habilite pelo menos um dos serviços usados nesse atendimento.",
    "en-US": "In the records of this group's attendants, enable at least one of the services used in this attendance.",
    "es-ES": "En el registro de los atendentes de este grupo, habilite al menos uno de los servicios usados en esta atención."
  },
  "LINK_AT_LEAST_ONE_ACTIVE_SERVICE_TO_GROUP": {
    "pt-BR": "Abra o cadastro do grupo de atendimento e vincule pelo menos um serviço ativo.",
    "en-US": "Open the service group record and link at least one active service.",
    "es-ES": "Abra el registro del grupo de atención y vincule al menos un servicio activo."
  },
  "REVIEW_PRIORITY_REGISTRATIONS_UNIQUE_WEIGHT": {
    "pt-BR": "Revise os cadastros de prioridade e deixe cada peso com um valor único.",
    "en-US": "Review the priority records and make each weight unique.",
    "es-ES": "Revise los registros de prioridad y deje cada peso con un valor único."
  },
  "LINKS": {
    "pt-BR": "Vínculos",
    "en-US": "Links",
    "es-ES": "Vínculos"
  },
  "LINK": {
    "pt-BR": "Vincular",
    "en-US": "Link",
    "es-ES": "Vincular"
  },
  "LINK_ENTITIES": {
    "pt-BR": "Vincular Entidades",
    "en-US": "Link Entities",
    "es-ES": "Vincular entidades"
  },
  "LINK_CHILD_ENTITIES_AFTER_CREATE_TITLE": {
    "pt-BR": "Vincular entidades filhas",
    "en-US": "Link child entities",
    "es-ES": "Vincular entidades hijas"
  },
  "LINK_CHILD_ENTITIES_AFTER_CREATE_DESCRIPTION": {
    "pt-BR": "Selecione em quais entidades filhas o novo cadastro ficarÃ¡ disponÃ­vel.",
    "en-US": "Select which child entities should receive the new record.",
    "es-ES": "Seleccione en quÃ© entidades hijas estarÃ¡ disponible el nuevo registro."
  },
  "CREATED_ITEM": {
    "pt-BR": "Cadastro criado",
    "en-US": "Created record",
    "es-ES": "Registro creado"
  },
  "SELECT_CHILD_ENTITIES_TO_LINK": {
    "pt-BR": "Escolha as entidades filhas que devem receber este cadastro.",
    "en-US": "Choose the child entities that should receive this record.",
    "es-ES": "Elija las entidades hijas que deben recibir este registro."
  },
  "NO_CHILD_ENTITIES_AVAILABLE_FOR_LINKING": {
    "pt-BR": "A entidade raiz selecionada não possui entidades filhas disponíveis para vínculo.",
    "en-US": "The selected root entity has no child entities available for linking.",
    "es-ES": "La entidad raíz seleccionada no tiene entidades hijas disponibles para vincular."
  },
  "SELECT_ALL": {
    "pt-BR": "Selecionar todas",
    "en-US": "Select all",
    "es-ES": "Seleccionar todas"
  },
  "CLEAR_SELECTION": {
    "pt-BR": "Limpar seleção",
    "en-US": "Clear selection",
    "es-ES": "Limpiar selección"
  },
  "SKIP_FOR_NOW": {
    "pt-BR": "Agora não",
    "en-US": "Not now",
    "es-ES": "Ahora no"
  },
  "POST_CREATE_CHILD_NOTICE_TITLE": {
    "pt-BR": "Aviso importante",
    "en-US": "Important notice",
    "es-ES": "Aviso importante"
  },
  "NEW_PRIORITY_CHILD_NOTICE": {
    "pt-BR": "Você cadastrou uma nova prioridade, solicite ao administrador da sua entidade raiz para vincular essa nova prioridade em seus serviços.",
    "en-US": "You created a new priority. Ask your root entity administrator to link this new priority to its services.",
    "es-ES": "Usted registró una nueva prioridad. Solicite al administrador de su entidad raíz que vincule esta nueva prioridad a sus servicios."
  },
  "NEW_SERVICE_CHILD_NOTICE": {
    "pt-BR": "Você cadastrou um novo serviço, solicite ao administrador da sua entidade raiz para vincular esse novo serviço em seus atendentes e grupos de serviços.",
    "en-US": "You created a new service. Ask your root entity administrator to link this new service to its attendants and service groups.",
    "es-ES": "Usted registró un nuevo servicio. Solicite al administrador de su entidad raíz que vincule este nuevo servicio a sus atendentes y grupos de servicios."
  },
  "NEW_SERVICE_GROUP_CHILD_NOTICE": {
    "pt-BR": "Você cadastrou um novo grupo de Serviço, solicite ao administrador da sua entidade raiz para vincular esse novo grupo em seus atendentes, locais e serviços.",
    "en-US": "You created a new service group. Ask your root entity administrator to link this new group to its attendants, locations, and services.",
    "es-ES": "Usted registró un nuevo grupo de servicio. Solicite al administrador de su entidad raíz que vincule este nuevo grupo a sus atendentes, ubicaciones y servicios."
  },
  "I_UNDERSTAND": {
    "pt-BR": "Entendi",
    "en-US": "I understand",
    "es-ES": "Entiendo"
  },
  "CATEGORY": {
    "pt-BR": "Categoria",
    "en-US": "Category",
    "es-ES": "Categoría"
  },
  "ENTITIES": {
    "pt-BR": "Entidades",
    "en-US": "Entities",
    "es-ES": "Entidades"
  },
  "SELECTED_ENTITY_IS_NOT_PRINCIPAL_SERVICES_WARNING": {
    "pt-BR": "A entidade selecionada não é a principal. Você pode visualizar os serviços vinculados, ou criar novos.",
    "en-US": "The selected entity is not the principal one. You can view linked services or create new ones.",
    "es-ES": "La entidad seleccionada no es la principal. Puede ver los servicios vinculados o crear nuevos."
  },
  "SELECTED_ENTITY_IS_NOT_PRINCIPAL_PRIORITIES_WARNING": {
    "pt-BR": "A entidade selecionada não é a principal. Você pode visualizar as prioridades vinculadas, ou criar novas.",
    "en-US": "The selected entity is not the principal one. You can view linked priorities or create new ones.",
    "es-ES": "La entidad seleccionada no es la principal. Puede ver las prioridades vinculadas o crear nuevas."
  },
  "SELECTED_ENTITY_IS_NOT_PRINCIPAL_RESOLUTIONS_WARNING": {
    "pt-BR": "A entidade selecionada não é a principal. Você pode visualizar as resoluções vinculadas, ou criar novas.",
    "en-US": "The selected entity is not the principal one. You can view linked resolutions or create new ones.",
    "es-ES": "La entidad seleccionada no es la principal. Puede ver las resoluciones vinculadas o crear nuevas."
  },
  "SELECTED_ENTITY_IS_NOT_PRINCIPAL_SERVICE_GROUPS_WARNING": {
    "pt-BR": "A entidade selecionada não é a principal. Você pode visualizar os grupos de atendimento vinculados, ou criar novos.",
    "en-US": "The selected entity is not the principal one. You can view linked service groups or create new ones.",
    "es-ES": "La entidad seleccionada no es la principal. Puede ver los grupos de atención vinculados o crear nuevos."
  },
  "SELECTED_ENTITY_IS_NOT_PRINCIPAL_ATTENDANTS_WARNING": {
    "pt-BR": "A entidade selecionada não é a principal. Você pode visualizar os atendentes vinculados, ou criar novos.",
    "en-US": "The selected entity is not the principal one. You can view linked attendants or create new ones.",
    "es-ES": "La entidad seleccionada no es la principal. Puede ver los atendentes vinculados o crear nuevos."
  },
  "CHILD_ENTITY_CAN_VIEW_LINKED_SERVICES_ONLY_ROOT_CAN_EDIT": {
    "pt-BR": "A entidade filha pode consultar os serviços vinculados, mas a edição continua disponível somente na entidade raiz.",
    "en-US": "The child entity can view linked services, but editing remains available only in the root entity.",
    "es-ES": "La entidad hija puede consultar los servicios vinculados, pero la edición sigue disponible solo en la entidad raíz."
  },
  "CHILD_ENTITY_CAN_VIEW_LINKED_PRIORITIES_ONLY_ROOT_CAN_EDIT": {
    "pt-BR": "A entidade filha pode consultar as prioridades vinculadas, mas a edição continua disponível somente na entidade raiz.",
    "en-US": "The child entity can view linked priorities, but editing remains available only in the root entity.",
    "es-ES": "La entidad hija puede consultar las prioridades vinculadas, pero la edición sigue disponible solo en la entidad raíz."
  },
  "CHILD_ENTITY_CAN_VIEW_LINKED_RESOLUTIONS_ONLY_ROOT_CAN_EDIT": {
    "pt-BR": "A entidade filha pode consultar as resoluções vinculadas, mas a edição continua disponível somente na entidade raiz.",
    "en-US": "The child entity can view linked resolutions, but editing remains available only in the root entity.",
    "es-ES": "La entidad hija puede consultar las resoluciones vinculadas, pero la edición sigue disponible solo en la entidad raíz."
  },
  "CHILD_ENTITY_CAN_VIEW_LINKED_SERVICE_GROUPS_ONLY_ROOT_CAN_EDIT": {
    "pt-BR": "A entidade filha pode consultar os grupos de atendimento vinculados, mas a edição continua disponível somente na entidade raiz.",
    "en-US": "The child entity can view linked service groups, but editing remains available only in the root entity.",
    "es-ES": "La entidad hija puede consultar los grupos de atención vinculados, pero la edición sigue disponible solo en la entidad raíz."
  },
  "CHILD_ENTITY_CAN_VIEW_LINKED_ATTENDANTS_ONLY_ROOT_CAN_EDIT": {
    "pt-BR": "A entidade filha pode consultar os atendentes vinculados, mas a edição continua disponível somente na entidade raiz.",
    "en-US": "The child entity can view linked attendants, but editing remains available only in the root entity.",
    "es-ES": "La entidad hija puede consultar los atendentes vinculados, pero la edición sigue disponible solo en la entidad raíz."
  },
  "SELECT_PRINCIPAL_ENTITY_TO_MANAGE_SHARED_LINKS": {
    "pt-BR": "Selecione uma entidade principal para gerenciar os vínculos compartilhados.",
    "en-US": "Select a principal entity to manage shared links.",
    "es-ES": "Seleccione una entidad principal para administrar los vínculos compartidos."
  },
  "CHOOSE_CATEGORY_THEN_ENTITY_TO_RECEIVE_ROOT_ITEMS": {
    "pt-BR": "Escolha primeiro a categoria e depois a entidade que vai receber os itens da raiz:",
    "en-US": "First choose the category and then the entity that will receive the root items:",
    "es-ES": "Primero elija la categoría y luego la entidad que recibirá los elementos de la raíz:"
  },
  "ENTITIES_AVAILABLE_FOR_CATEGORY": {
    "pt-BR": "Entidades disponíveis para a categoria:",
    "en-US": "Entities available for the category:",
    "es-ES": "Entidades disponibles para la categoría:"
  },
  "SELECT_AN_ENTITY": {
    "pt-BR": "Selecione uma entidade",
    "en-US": "Select an entity",
    "es-ES": "Seleccione una entidad"
  },
  "SHARED_SERVICES_CATEGORY_DESCRIPTION": {
    "pt-BR": "Escolha os serviços da raiz que deseja compartilhar com a entidade selecionada.",
    "en-US": "Choose the root services you want to share with the selected entity.",
    "es-ES": "Elija los servicios de la raíz que desea compartir con la entidad seleccionada."
  },
  "LINKED_SERVICES_TITLE": {
    "pt-BR": "Serviços vinculados",
    "en-US": "Linked services",
    "es-ES": "Servicios vinculados"
  },
  "SEARCH_SERVICE_PLACEHOLDER": {
    "pt-BR": "Buscar serviço...",
    "en-US": "Search service...",
    "es-ES": "Buscar servicio..."
  },
  "NO_SERVICE_FOUND_FOR_THIS_FILTER": {
    "pt-BR": "Nenhum serviço encontrado para este filtro.",
    "en-US": "No service found for this filter.",
    "es-ES": "No se encontró ningún servicio para este filtro."
  },
  "SHARED_PRIORITIES_CATEGORY_DESCRIPTION": {
    "pt-BR": "Selecione quais prioridades da raiz ficarão visíveis para a entidade escolhida.",
    "en-US": "Select which root priorities will be visible to the chosen entity.",
    "es-ES": "Seleccione qué prioridades de la raíz quedarán visibles para la entidad elegida."
  },
  "LINKED_PRIORITIES_TITLE": {
    "pt-BR": "Prioridades vinculadas",
    "en-US": "Linked priorities",
    "es-ES": "Prioridades vinculadas"
  },
  "SEARCH_PRIORITY_PLACEHOLDER": {
    "pt-BR": "Buscar prioridade...",
    "en-US": "Search priority...",
    "es-ES": "Buscar prioridad..."
  },
  "NO_PRIORITY_FOUND_FOR_THIS_FILTER": {
    "pt-BR": "Nenhuma prioridade encontrada para este filtro.",
    "en-US": "No priority found for this filter.",
    "es-ES": "No se encontró ninguna prioridad para este filtro."
  },
  "SHARED_RESOLUTIONS_CATEGORY_DESCRIPTION": {
    "pt-BR": "Defina quais resoluções da raiz estarão disponíveis para a entidade escolhida.",
    "en-US": "Define which root resolutions will be available to the chosen entity.",
    "es-ES": "Defina qué resoluciones de la raíz estarán disponibles para la entidad elegida."
  },
  "LINKED_RESOLUTIONS_TITLE": {
    "pt-BR": "Resoluções vinculadas",
    "en-US": "Linked resolutions",
    "es-ES": "Resoluciones vinculadas"
  },
  "SEARCH_RESOLUTION_PLACEHOLDER": {
    "pt-BR": "Buscar resolução...",
    "en-US": "Search resolution...",
    "es-ES": "Buscar resolución..."
  },
  "NO_RESOLUTION_FOUND_FOR_THIS_FILTER": {
    "pt-BR": "Nenhuma resolução encontrada para este filtro.",
    "en-US": "No resolution found for this filter.",
    "es-ES": "No se encontró ninguna resolución para este filtro."
  },
  "SHARED_SERVICE_GROUPS_CATEGORY_DESCRIPTION": {
    "pt-BR": "Selecione os grupos de atendimento da raiz que serão compartilhados com a entidade.",
    "en-US": "Select the root service groups that will be shared with the entity.",
    "es-ES": "Seleccione los grupos de atención de la raíz que se compartirán con la entidad."
  },
  "LINKED_SERVICE_GROUPS_TITLE": {
    "pt-BR": "Grupos vinculados",
    "en-US": "Linked groups",
    "es-ES": "Grupos vinculados"
  },
  "SEARCH_SERVICE_GROUP_PLACEHOLDER": {
    "pt-BR": "Buscar grupo...",
    "en-US": "Search group...",
    "es-ES": "Buscar grupo..."
  },
  "NO_SERVICE_GROUP_FOUND_FOR_THIS_FILTER": {
    "pt-BR": "Nenhum grupo encontrado para este filtro.",
    "en-US": "No group found for this filter.",
    "es-ES": "No se encontró ningún grupo para este filtro."
  },
  "SHARED_ATTENDANTS_CATEGORY_DESCRIPTION": {
    "pt-BR": "Defina quais atendentes da raiz ficarão visíveis para a entidade escolhida.",
    "en-US": "Define which root attendants will be visible to the chosen entity.",
    "es-ES": "Defina qué atendentes de la raíz quedarán visibles para la entidad elegida."
  },
  "LINKED_ATTENDANTS_TITLE": {
    "pt-BR": "Atendentes vinculados",
    "en-US": "Linked attendants",
    "es-ES": "Atendentes vinculados"
  },
  "SEARCH_ATTENDANT_PLACEHOLDER": {
    "pt-BR": "Buscar atendente...",
    "en-US": "Search attendant...",
    "es-ES": "Buscar atendente..."
  },
  "NO_ATTENDANT_FOUND_FOR_THIS_FILTER": {
    "pt-BR": "Nenhum atendente encontrado para este filtro.",
    "en-US": "No attendant found for this filter.",
    "es-ES": "No se encontró ningún atendente para este filtro."
  },
  "SAVE_LINKS": {
    "pt-BR": "Salvar vínculos",
    "en-US": "Save links",
    "es-ES": "Guardar vínculos"
  },
  "LINKS_SAVED_SUCCESSFULLY": {
    "pt-BR": "Vínculos salvos com sucesso.",
    "en-US": "Links saved successfully.",
    "es-ES": "Vínculos guardados con éxito."
  },
  "ONLY_ROOT_ENTITY_CAN_MANAGE_SERVICES": {
    "pt-BR": "Apenas a entidade raiz selecionada pode cadastrar ou alterar serviços.",
    "en-US": "Only the selected root entity can create or update services.",
    "es-ES": "Solo la entidad raíz seleccionada puede crear o editar servicios."
  },
  "ONLY_ROOT_ENTITY_CAN_MANAGE_PRIORITIES": {
    "pt-BR": "Apenas a entidade raiz selecionada pode cadastrar ou alterar prioridades.",
    "en-US": "Only the selected root entity can create or update priorities.",
    "es-ES": "Solo la entidad raíz seleccionada puede crear o editar prioridades."
  },
  "ONLY_ROOT_ENTITY_CAN_MANAGE_RESOLUTIONS": {
    "pt-BR": "Apenas a entidade raiz selecionada pode cadastrar ou alterar resoluções.",
    "en-US": "Only the selected root entity can create or update resolutions.",
    "es-ES": "Solo la entidad raíz seleccionada puede crear o editar resoluciones."
  },
  "ONLY_ROOT_ENTITY_CAN_MANAGE_SERVICE_GROUPS": {
    "pt-BR": "Apenas a entidade raiz selecionada pode cadastrar ou alterar grupos de atendimento.",
    "en-US": "Only the selected root entity can create or update service groups.",
    "es-ES": "Solo la entidad raíz seleccionada puede crear o editar grupos de atención."
  },
  "ONLY_ROOT_ENTITY_CAN_MANAGE_ATTENDANTS": {
    "pt-BR": "Apenas a entidade raiz selecionada pode cadastrar ou alterar atendentes.",
    "en-US": "Only the selected root entity can create or update attendants.",
    "es-ES": "Solo la entidad raíz seleccionada puede crear o editar atendentes."
  },
  "NO_SELECTED_ENTITY_TO_CREATE_SERVICES": {
    "pt-BR": "Nenhuma entidade selecionada para cadastrar serviços.",
    "en-US": "No entity selected to create services.",
    "es-ES": "No hay ninguna entidad seleccionada para crear servicios."
  },
  "NO_SELECTED_ENTITY_TO_CREATE_PRIORITIES": {
    "pt-BR": "Nenhuma entidade selecionada para cadastrar prioridades.",
    "en-US": "No entity selected to create priorities.",
    "es-ES": "No hay ninguna entidad seleccionada para crear prioridades."
  },
  "NO_SELECTED_ENTITY_TO_CREATE_RESOLUTIONS": {
    "pt-BR": "Nenhuma entidade selecionada para cadastrar resoluções.",
    "en-US": "No entity selected to create resolutions.",
    "es-ES": "No hay ninguna entidad seleccionada para crear resoluciones."
  },
  "NO_SELECTED_ENTITY_TO_CREATE_SERVICE_GROUPS": {
    "pt-BR": "Nenhuma entidade selecionada para cadastrar grupos de atendimento.",
    "en-US": "No entity selected to create service groups.",
    "es-ES": "No hay ninguna entidad seleccionada para crear grupos de atención."
  },
  "NO_SELECTED_ENTITY_TO_CREATE_ATTENDANTS": {
    "pt-BR": "Nenhuma entidade selecionada para cadastrar atendentes.",
    "en-US": "No entity selected to create attendants.",
    "es-ES": "No hay ninguna entidad seleccionada para crear atendentes."
  },
  "NO_SELECTED_ENTITY_TO_MANAGE_LOCATIONS": {
    "pt-BR": "Nenhuma entidade selecionada para gerenciar locais.",
    "en-US": "No entity selected to manage locations.",
    "es-ES": "No hay ninguna entidad seleccionada para administrar ubicaciones."
  },
  "COULD_NOT_LOCATE_CONFIGURED_ROOT_ENTITY": {
    "pt-BR": "Não foi possível localizar a entidade raiz configurada para este cadastro.",
    "en-US": "Could not locate the configured root entity for this record.",
    "es-ES": "No fue posible localizar la entidad raíz configurada para este registro."
  },
  "SIMILAR_NAME_WARNING_TITLE": {
    "pt-BR": "Cadastro semelhante encontrado",
    "en-US": "Similar record found",
    "es-ES": "Registro similar encontrado"
  },
  "SIMILAR_NAME_WARNING_MESSAGE": {
    "pt-BR": "Encontramos cadastros com nomes parecidos na entidade principal. Deseja continuar mesmo assim? Itens encontrados:",
    "en-US": "We found records with similar names in the main entity. Do you still want to continue? Found items:",
    "es-ES": "Encontramos registros con nombres parecidos en la entidad principal. Desea continuar de todos modos? Elementos encontrados:"
  },
  "SIMILAR_NAME_DUPLICATE_MESSAGE": {
    "pt-BR": "Ja existe um cadastro com nome equivalente na entidade principal. Revise o nome para continuar.",
    "en-US": "A record with an equivalent name already exists in the main entity. Review the name to continue.",
    "es-ES": "Ya existe un registro con un nombre equivalente en la entidad principal. Revise el nombre para continuar."
  }
}
